import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';
import { distinctUntilChanged } from 'rxjs/operators';
import { NetworkService } from './network.service';

@Injectable({
  providedIn: 'root',
})
export class NetworkStatusNotifierService {
  private initialized = false;
  private connectionProblemActive = false;
  private lastWarningAt = 0;
  private lastRecoveredAt = 0;

  private readonly repeatWarningCooldownMs = 15000;
  private readonly recoveredCooldownMs = 3000;

  constructor(
    private networkService: NetworkService,
    private toastrService: NbToastrService
  ) {}

  init(): void {
    if (this.initialized) {
      return;
    }

    this.initialized = true;

    this.networkService.online$
      .pipe(distinctUntilChanged())
      .subscribe((isOnline) => {
        if (isOnline) {
          this.showRecoveredToast();
          return;
        }

        // this.showWarningToast(
        //   'اتصال اینترنت دستگاه قطع شده است. لطفا وضعیت شبکه را بررسی کنید.'
        // );
      });
  }

  reportHttpError(error: HttpErrorResponse): void {
    if (!this.isNetworkError(error)) {
      return;
    }

    // const message = navigator.onLine
    //   ? 'در ارتباط با سرور اختلال وجود دارد. اینترنت، فیلترشکن یا تنظیمات پراکسی را بررسی کنید.'
    //   : 'اتصال اینترنت دستگاه قطع است. بعد از اتصال دوباره، عملیات را تکرار کنید.';

    // this.showWarningToast(message);
  }

  reportConnectionProblem(message: string): void {
    this.showWarningToast(message);
  }

  reportConnectionRecovered(): void {
    this.showRecoveredToast();
  }

  private isNetworkError(error: HttpErrorResponse): boolean {
    return error.status === 0;
  }

  private showWarningToast(message: string): void {
    const now = Date.now();
    if (
      this.connectionProblemActive &&
      now - this.lastWarningAt < this.repeatWarningCooldownMs
    ) {
      return;
    }

    this.lastWarningAt = now;
    this.connectionProblemActive = true;
    this.toastrService.show(message, 'اختلال در اتصال', {
      destroyByClick: true,
      duration: 6000,
      limit: 3,
      position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
      preventDuplicates: true,
      status: 'warning',
    });
  }

  private showRecoveredToast(): void {
    if (!this.connectionProblemActive) {
      return;
    }

    this.connectionProblemActive = false;

    const now = Date.now();
    if (now - this.lastRecoveredAt < this.recoveredCooldownMs) {
      return;
    }

    this.lastRecoveredAt = now;
    this.toastrService.show('اتصال اینترنت دوباره برقرار شد.', 'اتصال برقرار شد', {
      destroyByClick: true,
      duration: 3000,
      limit: 3,
      position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
      preventDuplicates: true,
      status: 'success',
    });
  }
}
